<template>
    <div class="content-wrapper">
        <section class="content-header">
            <h1>
                {{ $t('dashboard') }}

                <button
                    type="button"
                    class="btn btn-sm btn-primary btn-icon btn-round ml5"
                    data-toggle="popover"
                    data-trigger="focus"
                    data-placement="right"
                    :data-html="true"
                    title="How work dashboard"
                    data-content="Statistics are calculated based on the date range.
                    The statistic is calculated by all messages with the send date in the selected date
                    range. The statistics show clicks and revenues that were created in the selected range."
                >
                    <i class="fa fa-info" />
                </button>
            </h1>
        </section>

        <section class="content">
            <Alerts />

            <div class="nav-tabs-custom nav-tabs-custom-dynamic">
                <ul
                    :class="{ disabled: disabledDynamicFilter }"
                    class="nav nav-tabs"
                    @click.prevent.stop="!disabledDynamicFilter"
                >
                    <li
                        v-for="(value, index) in tabs"
                        :key="value.id"
                        :class="{ active: value.active }"
                        @click="!disabledDynamicFilter && setActive(value.id)"
                    >
                        <input
                            v-show="value.edit"
                            ref="tabName"
                            :value="value.name"
                            type="text"
                            class="input-edit-tab"
                            @keyup.enter="saveTab(index)"
                        />
                        <a
                            v-show="!value.edit"
                            :href="'#' + value.id"
                            aria-expanded="true"
                            class="custom-link"
                            data-toggle="tab"
                        >
                            {{ value.name }}
                        </a>
                        <div class="control-tab">
                            <span
                                v-if="value.edit"
                                class="save-tab"
                                @click.stop="!disabledDynamicFilter && saveTab(index)"
                            >
                                <i class="fa fa-check"></i>
                            </span>
                            <span
                                v-else
                                class="edit-tab"
                                @click.stop="!disabledDynamicFilter && editTab(index)"
                            >
                                <i class="fa fa-pencil"></i>
                            </span>
                            <span
                                class="close-tab"
                                @click.stop="!disabledDynamicFilter && closeTab(value.id)"
                            >
                                <i class="fa fa-close"></i>
                            </span>
                        </div>
                    </li>
                    <li
                        class="add-new-tab"
                        @click="!disabledDynamicFilter && newTab()"
                    >
                        <i class="fa fa-plus"></i>
                    </li>
                </ul>

                <div class="tab-content tab-content--background">
                    <div
                        v-for="reportsTab in tabs"
                        :id="reportsTab.id"
                        :key="reportsTab.id"
                        :class="{ active: reportsTab.active }"
                        class="tab-pane table-responsive"
                    >
                        <DashboardFilters
                            ref="filters"
                            :count="reportsTab.count"
                            :dataItems="dataMainItems"
                            :disabledDynamicFilter="disabledDynamicFilter"
                            :externalParams="reportsTab.externalParams"
                            :idTab="reportsTab.id"
                            :collapseChart="collapseChart"
                            @changeFilterParameter="changeFilterParameter"
                            @setLoading="isLoading = $event"
                            @setChartsLoading="isChartsLoading = $event"
                            @setDisabledDynamicFilter="setDisabledDynamicFilter"
                            @setMainItems="setMainItems"
                            @setReport="setReport(reportsTab, $event)"
                        />

                        <DashboardCharts
                            ref="charts"
                            :isChartsLoading="isChartsLoading"
                            :report="reportsTab.report"
                            :getReportByDates="getReportByDates"
                        />

                        <DashboardTable
                            ref="tables"
                            :isLoading="isLoading"
                            :report="reportsTab.report"
                            :typeReport="reportsTab.typeReport"
                            :additionalRelationTitles="reportsTab.additionalRelationTitles"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import LZString from 'lz-string';
import DashboardFilters from '@/components/dashboard/advanced/DashboardFilters';
import DashboardCharts from '@/components/dashboard/advanced/DashboardCharts';
import DashboardTable from '@/components/dashboard/advanced/DashboardTable';

export default {
    name: 'Dashboard',
    components: {
        DashboardFilters,
        DashboardCharts,
        DashboardTable,
    },
    data() {
        return {
            isLoading: false,
            isChartsLoading: false,
            tabs: [],
            dataMainItems: [],
            disabledDynamicFilter: false,
            countLoadedTab: 0,
            loadedTabs: false,
            disabledDynamicFilterItems: [],
        };
    },
    mounted() {
        $(document).on('shown.bs.modal', () => {
            $('[data-toggle="popover"]').popover();
        });

        this.loadTabsByParams();
    },
    methods: {
        newTab(data) {
            let lastTab = this.tabs.slice(-1).pop();
            let count = lastTab && lastTab.count ? lastTab.count + 1 : 1;
            let item = {
                id: 'tab_' + count,
                count: count,
                active: count === 1,
                name: data && data.tab && data.tab.name ? data.tab.name : 'Report #' + count,
                manualName: data && data.tab && data.tab.manualName ? data.tab.manualName : false,
                externalParams: data || null,
                edit: false,
            };
            this.tabs.push(item);
        },
        closeTab(id) {
            let self = this;
            self.tabs.forEach(function (item, index) {
                if (item.id === id && item.active === true) {
                    if (self.tabs[index - 1]) {
                        self.tabs[index - 1].active = true;
                    } else if (self.tabs[index + 1]) {
                        self.tabs[index + 1].active = true;
                    }
                }
            });
            self.tabs = self.tabs.filter(function (item) {
                return item.id !== id;
            });
            this.changeFilterParameter();
        },
        editTab(index) {
            this.tabs.map(function (value, indexTab) {
                value.edit = indexTab === index;
                return value;
            });
            this.$nextTick(() => {
                this.$refs['tabName'][index].focus();
            });
        },
        saveTab(index) {
            this.tabs[index].name = this.$refs['tabName'][index].value;
            this.tabs[index].edit = false;
            this.tabs[index].manualName = true;
            this.changeFilterParameter();
        },
        setActive(id) {
            this.tabs.map(function (value) {
                value.active = value.id === id;
                return value;
            });
        },
        setMainItems(data, id) {
            this.dataMainItems[id] = data;
        },
        setDisabledDynamicFilter(allDataLoaded) {
            this.disabledDynamicFilter = !(!allDataLoaded && this.loadedTabs);
            if (!allDataLoaded && !this.loadedTabs) {
                this.loadTabsByParams();
            }
        },
        loadTabsByParams() {
            let params =
                this.$route.query.key && this.$route.query.key.length > 0
                    ? JSON.parse(LZString.decompressFromEncodedURIComponent(this.$route.query.key))
                    : null;

            // Generate new tab
            if (params) {
                params[this.countLoadedTab] && this.newTab(params[this.countLoadedTab]);
                this.countLoadedTab++;
                !params[this.countLoadedTab] && (this.loadedTabs = true);
            } else {
                this.newTab();
                this.loadedTabs = true;
            }
        },
        changeFilterParameter() {
            if (!this.loadedTabs) {
                return false;
            }
            let self = this;
            let tabsParams = [];

            self.tabs.forEach(function (tabValue, indexTab) {
                if (!self.$refs.filters) {
                    return;
                }

                self.$refs.filters.forEach(function (filterVal) {
                    if (tabValue.id === filterVal.idTab) {
                        if (!tabValue.externalParams) {
                            tabValue.externalParams = {};
                        }

                        let itemParams = {};
                        filterVal.formItems.forEach(function (itemVal) {
                            let currentRef = filterVal.getCurrentRef(itemVal.id);
                            if (currentRef) {
                                let valueRef = currentRef.getValue();
                                if (valueRef !== null) {
                                    let idProp = itemVal.id;
                                    if (idProp === 'date') {
                                        let dateSplit = valueRef.split(' - ');
                                        itemParams['start'] = dateSplit[0];
                                        itemParams['end'] = dateSplit[1];
                                    } else {
                                        tabValue.externalParams[idProp] = valueRef;
                                        itemParams[idProp] = valueRef;
                                    }
                                }
                            }
                        });

                        if (
                            self.tabs.length > 1 ||
                            (indexTab === 0 &&
                                ((!self.isDefaultParams(itemParams) && !self.isEmptyObject(itemParams)) || tabValue.manualName))
                        ) {
                            tabsParams.push(itemParams);
                        }
                    }
                });
            });

            // Params for tabs
            self.tabs.forEach(function (tab, index) {
                let tabName = tab.manualName ? tab.name : self.prepareDynamicTabsName(tabsParams[index], tab);
                let tabData = {
                    id: tab.id,
                    name: tabName,
                    manualName: tab.manualName,
                };
                if (tabsParams[index]) {
                    tabsParams[index]['tab'] = tabData;
                }

                // Set current name
                tab.name = tabName;
            });

            tabsParams = tabsParams.length > 0 ? { key: LZString.compressToEncodedURIComponent(JSON.stringify(tabsParams)) } : '';
            self.pushToRoute(tabsParams);
        },
        isDefaultParams(itemParams) {
            return (
                Object.keys(itemParams).length <= 3 &&
                window.moment().format('YYYY-MM-DD') === itemParams['start'] &&
                window.moment().format('YYYY-MM-DD') === itemParams['end'] &&
                this.checkDefaultFilters(itemParams)
            );
        },
        checkDefaultFilters(itemParams) {
            return (
                itemParams['withoutClickServer'] &&
                itemParams['withoutClickServer'] === 'none' &&
                (!itemParams['clickerFilter'] || this.isEmptyObject(itemParams['clickerFilter']))
            );
        },
        prepareDynamicTabsName(currentTab, tab) {
            if (!currentTab || this.isEmptyObject(currentTab) || this.isDefaultParams(currentTab)) {
                return 'Report #' + tab.count;
            }

            let tabName = '';
            let nameData = [];
            let filtersName = '';
            for (let key in currentTab) {
                let value = currentTab[key];

                if (['start', 'end', 'tab', 'filter', 'onlyActive'].includes(key)) {
                    continue;
                }

                if (key === 'groupBy') {
                    nameData.push({
                        sort: 1,
                        name: this.$refs.filters[0].itemsGroupBy.find((el) => {
                            return el.id === value;
                        }).name,
                    });
                } else if (key === 'clickerFilter') {
                    !this.isEmptyObject(value) &&
                        nameData.push({
                            sort: 2,
                            name: 'by Clicker Filter',
                        });
                } else if (key === 'withoutClickServer') {
                    value !== 'none' &&
                        nameData.push({
                            sort: 3,
                            name: value === '1' ? 'w/o CS' : 'w/ CS',
                        });
                } else if (Object.keys(value).length > 0) {
                    let name = this.$refs.filters[0].itemsFilter.find((el) => {
                        return el.id === key;
                    }).name;
                    filtersName = filtersName ? filtersName + ', ' + name : 'by ' + name;
                }
            }

            // Filters
            filtersName &&
                nameData.push({
                    sort: 4,
                    name: filtersName,
                });

            // Date
            currentTab.start &&
                currentTab.end &&
                nameData.push({
                    sort: 5,
                    name: currentTab.start === currentTab.end ? currentTab.start : currentTab.start + ' - ' + currentTab.end,
                });

            // Prepare a row from a collection
            nameData
                .sort((a, b) => a.sort - b.sort)
                .forEach(function (item) {
                    tabName && (tabName += ' | ');
                    tabName += item.name;
                });

            return tabName;
        },
        pushToRoute(params) {
            this.$router
                .push({
                    path: this.$route.path,
                    query: params,
                    name: 'dashboard.advanced',
                })
                .catch(() => {});
        },
        isEmptyObject(obj) {
            for (let i in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, i)) {
                    return false;
                }
            }
            return true;
        },
        setReport(tab, data) {
            this.tabs.find((reportsTab) => {
                if (tab.id === reportsTab.id) {
                    tab.report = data.report;
                    tab.typeReport = data.typeReport;
                    tab.additionalRelationTitles = data.additionalRelationTitles;
                }
            });
        },
        getReportByDates() {
            this.tabs.find((reportsTab, i) => {
                if (reportsTab.active) {
                    this.$refs.filters[i].getReport(false, true);
                }
            });
        },
        collapseChart() {
            this.tabs.find((reportsTab, i) => {
                if (reportsTab.active) {
                    this.$refs.charts[i].collapseChart();
                }
            });
        },
    },
};
</script>
